module.exports = __webpack_public_path__ + "static/media/video-thumbnail-desktop-en.b76155e0.png";